// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-fe3eda3a]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.agreement[data-v-fe3eda3a] {\n  padding-top: 40px;\n  padding-bottom: 80px;\n}\n.agreement[data-v-fe3eda3a] h4 {\n  font-size: 16px;\n  font-family: AlibabaPuHuiTiM;\n  padding: 12px 0;\n}\n.agreement[data-v-fe3eda3a] p {\n  padding: 12px 0;\n}\n.agreement[data-v-fe3eda3a] .sub {\n  padding-left: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
